<template>
  <div class="" :style="{marginTop: margintop + 'px'}">
    <!--    <header-module1 :navdata="navdata" :layerseries="layerSeries" :appdata="appdata"></header-module1>-->
    <header-module2 :class="{'colorconfig': colorconfig}" :navdata="navdata" :layerseries="layerSeries" :appdata="appdata"></header-module2>
  </div>
</template>

<script>
import headerModule2 from '@/components/header/HeaderModule2'
import { getMenuList } from '@/api/menu/index'
import { userservice, getfrontslot } from '@/api/userservice/index'
export default {
  name: 'index',
  data () {
    return {
      slotData: '',
      slotTimer: null,
      colorconfig: false,
      margintop: '',
      navdata: [],
      appdata: '',
      layerSeries: 0 // 层级数
    }
  },
  components: {
    headerModule2
  },
  mounted () {
    this.getMenu()
    this.getSlot()
  },
  methods: {
    headerHeight (val) {
      this.margintop = val
    },
    /* 获取应用配置 */
    getUserservice () {
      userservice(this.$cookie.get('museumCode')).then((res) => {
        if (res.data.rel) {
          this.appdata = res.data.data
          document.title = this.appdata.title
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    /* 获取菜单层级数 */
    recursion (obj, k) {
      this.layerSeries = Math.max(this.layerSeries, k)
      if (obj.children) {
        obj.children.forEach((v, i) => {
          this.recursion(v, k + 1)
        })
      }
      return this.layerSeries
    },
    /* 获取菜单 */
    getMenu () {
      getMenuList(this.$cookie.get('museumCode')).then((res) => {
        if (res.status === 200) {
          let layerSeries = this.recursion(res.data[0], 1)
          this.layerSeries = layerSeries
          let menudata = ''
          // 是否有子首页
          if (this.$route.query.subhomepage !== undefined) {
            this.subhomepage = this.$route.query.subhomepage
            this.slotTimer = setInterval(() => {
              if (this.slotData !== '') {
                clearInterval(this.slotTimer)
                this.slotData.forEach(item => {
                  // 子首页配置列表页相应菜单
                  if (item.slotName === 'subhomepage') {
                    if (item.adDetails.length > 0) {
                      item.adDetails.forEach(items => {
                        if (items.adName === this.$route.query.subhomepage) {
                          if (items.imgPath !== undefined) {
                            this.appdata = {appLogo: items.imgPath}
                          } else {
                            this.appdata = {appLogo: ''}
                          }
                          document.title = items.adDesc
                          let menueqid = parseInt(items.adCode)
                          menudata = res.data[0].children[menueqid].children
                          menudata.unshift({'id': 0, 'title': '首页', 'index': true, 'href': items.adLink, 'subhomepage': item.adName})
                          this.setNavdata(menudata)
                        }
                      })
                    }
                  }
                })
              }
            }, 100)
          } else {
            menudata = res.data[0].children
            console.log(localStorage.getItem('departmentCode'))
            if (localStorage.getItem('departmentCode') !== null && localStorage.getItem('departmentCode') !== '') {
              menudata.unshift({'id': 0, 'title': '首页', 'index': true, 'href': location.protocol + '//' + location.host + '/' + localStorage.getItem('departmentCode') + '.html'})
            } else {
              menudata.unshift({'id': 0, 'title': '首页', 'index': true})
            }
            this.setNavdata(menudata)
            this.getUserservice()
          }
        }
      })
    },
    setNavdata (menudata) {
      // PC端 菜单选择前端显示时 过滤 移动端配置导航菜单
      let filterData = menudata.filter(item => item.description === undefined || (item.description !== undefined && item.description !== 'mobilenav'))
      // 南涧项目 导航菜单全部显示
      if (this.$cookie.get('museumCode') === 'Njggwhy') {
        this.navdata = filterData
        this.$store.dispatch('saveMenuList', this.navdata)
      } else {
        if (filterData.length > 7) {
          this.navdata = filterData.slice(0, 7)
          let moredata = {
            'id': 8,
            'title': '更多',
            'children': filterData.slice(7, filterData.length)
          }
          this.navdata.push(moredata)
        } else {
          this.navdata = filterData
        }
        this.$store.dispatch('saveMenuList', this.navdata)
      }
    },
    // 拆分数组
    arrayChunk (array, size) {
      let data = []
      for (let i = 0; i < array.length; i += size) {
        data.push(array.slice(i, i + size))
      }
      return data
    },
    getSlot () {
      let params = {
        museumCode: this.$cookie.get('museumCode'),
        slotName: '',
        slotCode: ''
      }
      getfrontslot(params).then(res => {
        if (res.data.status === 200) {
          this.$store.dispatch('saveSlotList', res.data.data.rows)
          if (res.data.data.rows.length > 0) {
            this.slotData = res.data.data.rows
            res.data.data.rows.forEach(item => {
              // 配置头部背景色
              if (item.slotName === 'PCheadercolor') {
                if (item.slotDesc.length > 0) {
                  this.colorconfig = true
                  let colorObj = JSON.parse(item.slotDesc)
                  let colorstyle = '.headermodule-2.colorconfig,.el-menu--horizontal .el-menu.el-menu--popup{background: ' + colorObj.color + '!important;} .headermodule-2.colorconfig .el-menu.el-menu-demo div li.is-opened .el-submenu__title, .headermodule-2.colorconfig .el-menu.el-menu-demo div li:hover .el-submenu__title{background:' + colorObj.hovercolor + '!important;}'
                  this.importStyle(colorstyle)
                }
              }
            })
          }
        }
      })
    },
    importStyle (b) {
      let a = document.createElement('style')
      let c = document
      c.getElementsByTagName('head')[0].appendChild(a)
      if (a.styleSheet) {
        a.styleSheet.cssText = b
      } else {
        a.appendChild(c.createTextNode(b))
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/header/index.vue